module.exports = __webpack_public_path__ + "front/img/1.3c562b5d.png";